import { EntityTypes, MergedEntityTypes } from '../../../../fr-entity-panels/types';
import { UNKNOWN_ENTITIES_CARDS_LABELS } from './constants';

export function getPersonTitle({
    fullName,
    index,
    entityType,
}: {
    fullName: string | null;
    index: number;
    entityType: EntityTypes | MergedEntityTypes;
}) {
    if (!fullName) {
        return `${UNKNOWN_ENTITIES_CARDS_LABELS[entityType]} ${index + 1}`;
    }

    const splitName = fullName.split(' ');
    const lastName = splitName.pop();

    return `${lastName}, ${splitName.join(' ')}`;
}

export function getVehicleTitle({
    plateNumber,
    state,
    index,
    entityType,
}: {
    plateNumber: string | null;
    state?: string;
    index: number;
    entityType: EntityTypes | MergedEntityTypes;
}) {
    if (plateNumber && state) {
        return `${plateNumber}, ${state}`;
    }

    if (plateNumber) return plateNumber;
    if (state) return state;

    return `${UNKNOWN_ENTITIES_CARDS_LABELS[entityType]} ${index + 1}`;
}

export function getEntityDescription(
    descriptionLabelsList: (string | number | null | undefined)[]
) {
    const validLabels = descriptionLabelsList.filter((descriptionLabel) => descriptionLabel);

    if (validLabels.length === 0) {
        return 'No description';
    }

    return validLabels.join(', ');
}

export function getPersonDisplayDOBOrAge({
    dateOfBirth,
    ageMax,
    ageMin,
}: {
    dateOfBirth?: string | null;
    ageMax?: number | null;
    ageMin?: number | null;
}) {
    if (dateOfBirth) {
        return new Date(dateOfBirth.replace(/-/g, '/')).toLocaleDateString('en-US', {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
        });
    }

    if (ageMax && ageMin) {
        return `${ageMin} - ${ageMax}`;
    }

    if (ageMin) {
        return `from ${ageMin}`;
    }

    if (ageMax) {
        return `up to ${ageMax}`;
    }

    return '--';
}

export function getPersonDisplayWeightOrHeight({
    value,
    max,
    min,
}: {
    value?: string | number | null;
    max?: string | number | null;
    min?: string | number | null;
}) {
    if (value) {
        return value;
    }

    if (min && max) {
        return `${min} - ${max}`;
    }

    if (min) {
        return `from ${min}`;
    }

    if (max) {
        return `up to ${max}`;
    }

    return null;
}

export function getPhoneNumberInDisplayedFormat(phoneNumber: string) {
    const splitPhoneNumber = phoneNumber.split('');
    splitPhoneNumber.splice(0, 0, '(');
    splitPhoneNumber.splice(4, 0, ')');
    splitPhoneNumber.splice(5, 0, ' ');
    splitPhoneNumber.splice(9, 0, '-');

    return splitPhoneNumber.join('');
}

export function getHeightInDisplayedFormat(height?: string | number | null) {
    if (!height) {
        return null;
    }

    const stringifiedHeight = typeof height === 'string' ? height : String(height);
    const splitHeight = stringifiedHeight.split('');
    splitHeight.splice(splitHeight.length - 2, 0, `'`);

    return splitHeight.join('');
}

export function getPersonYearOfBirth(dateOfBirth: string | null | undefined) {
    if (!dateOfBirth) {
        return;
    }

    return new Date(dateOfBirth.replace(/-/g, '/')).getFullYear();
}

export function getEntityIconAvatar(
    isPerson: boolean,
    isProperty: boolean,
    type: EntityTypes | MergedEntityTypes
) {
    if (isPerson) {
        return 'Person';
    }
    if (isProperty)
        return type === 'firearms' || type === 'mergedFirearms' ? 'Firearm' : 'Property';

    return 'Vehicle';
}

export function getPersonSexNcicCode(personSexLabel?: string) {
    if (!personSexLabel) {
        return;
    }

    switch (personSexLabel) {
        case 'Male':
            return 'M';
        case 'Female':
            return 'F';
        case 'Unknown':
            return 'X';
        default:
            return;
    }
}
